import { render } from "./UserEditor.vue?vue&type=template&id=4e60aebe"
import script from "./UserEditor.vue?vue&type=script&lang=js"
export * from "./UserEditor.vue?vue&type=script&lang=js"

import "./UserEditor.vue?vue&type=style&index=0&id=4e60aebe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__